import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { adminListSubscribers } from "@/lib/admin.functions";
import { formatDate } from "@/lib/site";

export const Route = createFileRoute("/admin/subscribers")({
  component: SubscribersPage,
});

function SubscribersPage() {
  const { data, isLoading } = useQuery({
    queryKey: ["admin", "subscribers"],
    queryFn: () => adminListSubscribers(),
  });

  function downloadCsv() {
    if (!data) return;
    const header = "email,source,created_at,confirmed_at\n";
    const rows = data
      .map((s) => [s.email, s.source ?? "", s.created_at ?? "", s.confirmed_at].join(","))
      .join("\n");
    const blob = new Blob([header + rows], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `subscribers-${new Date().toISOString().slice(0, 10)}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  }

  const active = data?.filter((s) => !s.unsubscribed_at) ?? [];
  const unsubbed = data?.filter((s) => !!s.unsubscribed_at).length ?? 0;

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="headline-display text-3xl">Subscribers</h1>
          <p className="text-sm text-muted-foreground mt-1">
            {active.length} active · {unsubbed} unsubscribed
          </p>
        </div>
        <button
          onClick={downloadCsv}
          disabled={!data || data.length === 0}
          className="border border-border px-3 py-2 text-sm hover:bg-paper-soft disabled:opacity-50"
        >
          Export CSV
        </button>
      </div>
      {isLoading ? (
        <p className="text-muted-foreground">Loading…</p>
      ) : !data || data.length === 0 ? (
        <div className="border border-dashed border-border p-12 text-center text-muted-foreground">
          No subscribers yet.
        </div>
      ) : (
        <table className="w-full text-sm border-collapse">
          <thead>
            <tr className="text-left border-b border-border">
              <th className="py-2 pr-3 font-medium">Email</th>
              <th className="py-2 pr-3 font-medium">Source</th>
              <th className="py-2 pr-3 font-medium">Subscribed</th>
              <th className="py-2 pr-3 font-medium">Status</th>
            </tr>
          </thead>
          <tbody>
            {data.map((s) => (
              <tr key={s.id} className={`border-b border-border hover:bg-paper-soft ${s.unsubscribed_at ? "opacity-50" : ""}`}>
                <td className="py-2 pr-3">{s.email}</td>
                <td className="py-2 pr-3 text-muted-foreground">{s.source ?? "—"}</td>
                <td className="py-2 pr-3 text-muted-foreground">{formatDate(s.created_at)}</td>
                <td className="py-2 pr-3">{s.unsubscribed_at ? "Unsubscribed" : s.confirmed_at ? "Active" : "Pending"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
